import { render, staticRenderFns } from "./XmSingleRadio.vue?vue&type=template&id=70dffbf9&scoped=true"
import script from "./XmSingleRadio.vue?vue&type=script&lang=js"
export * from "./XmSingleRadio.vue?vue&type=script&lang=js"
import style0 from "./XmSingleRadio.vue?vue&type=style&index=0&id=70dffbf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dffbf9",
  null
  
)

export default component.exports